import { render } from "./NcContent.vue?vue&type=template&id=31bf3323&scoped=true"
import script from "./NcContent.vue?vue&type=script&lang=js"
export * from "./NcContent.vue?vue&type=script&lang=js"

import "./NcContent.vue?vue&type=style&index=0&id=31bf3323&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bf3323"]])

export default __exports__